import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FuncsService } from '../services/funcs.service';
import { CustomerCurrent } from '../data/customer';
import { ResetPasswordService } from '../services/resetPassword.service';
import { Subscription, timer } from 'rxjs';
import { Dealer, DealerCurrent } from '../data/dealer';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  standalone: false
})
export class ChangePasswordComponent {

  errormsg: string = "";
  msg: string = "";

  password: string = "";
  confirmPassword: string = "";

  ref: any;
  fleet: boolean = false;
  dlr: boolean = false;

  dealer: Dealer = DealerCurrent;

  username = "";

  private subcriptionTimer!: Subscription;

  constructor(
    private funcs: FuncsService,
    private passwordService: ResetPasswordService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.msg = "";
    this.errormsg = "";

    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      } else if (this.ref == "dealer") {
        this.dlr = true;
      }
    });

    if (this.ref == "fleet" || CustomerCurrent.role === "FLEET") {
      this.fleet = true;
    } else if (this.ref == "dealer" || CustomerCurrent.role == "DEALER" || CustomerCurrent.role == "INT_DEALER") {
      this.dlr = true;
    }

    if (this.fleet || this.dlr) {
      this.funcs.currentDealer(this.dealer);
      this.username = this.getUsername(this.dealer.pa_code);
    } else {
      this.funcs.checkAdmin();
      this.funcs.currentCustomer(CustomerCurrent);
      this.username = CustomerCurrent.username;
    }
  }

  getUsername(pa_code: string): string {
    var country = this.funcs.getThreeLetterCountry(pa_code);
    if (country == "USA" || country == "CAN") {
      pa_code = pa_code.slice(3);
    }
    var username = "";
    if (this.fleet) {
      username = `FIN${pa_code}`;
    } else if (this.dlr) {
      username = `FCT${pa_code}`
    }

    return username;
  }

  ngOnDestroy(): void {
    this.subcriptionTimer?.unsubscribe();
  }

  changePassword() {
    this.msg = "";
    this.errormsg = "";
    if (this.password != this.confirmPassword) {
      this.errormsg = "Password and Confirm Password should match.";
      return;
    }
    this.passwordService.changePassword(this.username, this.password).subscribe(result => {
      if (result) {
        this.msg = "Password changed.";
        // this.subcriptionTimer = timer(3000).subscribe(() => {
        //   this.router.navigateByUrl('/home');
        // });
        // setTimeout(() => {
        //   this.router.navigateByUrl('/home');
        // }, 3000); // 3 seconds
      } else {
        this.errormsg = "Password change failed.";
      }
    });
  }
}
